<template>
  <v-data-table
    item-key="id"
    :items-per-page="5"
    :headers="headers"
    :items="data"
    loading-text="Đang Tải"
    no-data-text="Không có dữ liệu"
  >
    <template v-slot:[`item.amountMoney`]="{ item }">
      {{ $utils.formatMoney(item.amountMoney) }}
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Mã học sinh',
          value: 'studentCode',
          align: 'left',
          sortable: false,
          width: '170px',
        },
        {
          text: 'Ngân hàng',
          value: 'bankName',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Số tài khoản',
          value: 'accountNumber',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Tên tài khoản',
          value: 'accountName',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Số tiền',
          value: 'amountMoney',
          align: 'left',
          sortable: false,
        },
      ],
    }
  },
}
</script>

<style></style>
